import { useCallback } from 'react';
import { agreementsApi } from '@/modules/agreements/services/api';
import { useAsyncResource } from '@/shared/hooks/use-async-resource';
import { isForbidden } from '@/modules/agreements/shared';

/** The execution being signed, plus the reload used after a successful signature. */
export function useSigningExecution(executionId: string) {
  const load = useCallback(() => agreementsApi.getMyExecution(executionId), [executionId]);
  const { data, error, isLoading, reload } = useAsyncResource(load);
  return { execution: data, error, isLoading, reload, isDenied: isForbidden(error) };
}
